<ng-container *ngFor="let item of list">
  <a [routerLink]="['/network',item.virtId]"
     class="list-group-item transition item-sub sub"
     data-parent="#menu1sub1" >
    {{item.name}}
  </a>
</ng-container>




